<p-dialog
  [visible]="visible"
  (visibleChange)="visibleChanged($event)"
  position="right"
  [style]="{ width: 'min(520px, 100vw)', height: '100dvh', maxHeight: '100dvh', margin: '0' }"
  [contentStyle]="{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving"
  [header]="'FLEXI_SAFETY_ROUNDS.ASSIGN.MANAGE_TITLE' | translate: { name: templateName }"
>
  <div class="fvr-assign" [attr.aria-busy]="saving || loading || assignmentsLoading">
    @if (saving) {
      <p class="fvr-action-status" role="status">{{ 'FLEXI_SAFETY_ROUNDS.FEEDBACK.UPDATING' | translate }}</p>
    }
    <p class="fas-muted">{{ 'FLEXI_SAFETY_ROUNDS.ASSIGN.INTRO' | translate }}</p>

    <h3 class="fvr-h3" id="fvr-assigned-list-heading">{{ 'FLEXI_SAFETY_ROUNDS.EDITOR.ASSIGNED' | translate }}</h3>
    <div class="fvr-assign__list" [class.fvr-assign__list--assigned]="canAssign" aria-labelledby="fvr-assigned-list-heading">
      @if (assignmentsLoading) {
        <flexi-safety-round-skeleton />
      } @else if (assignmentsLoadFailed) {
        <p class="fas-error" role="alert">{{ 'FLEXI_SAFETY_ROUNDS.LOAD_FAILED' | translate }}</p>
        <button type="button" class="fas-btn fas-btn--ghost" (click)="loadAssignments()">{{ 'FLEXI_SAFETY_ROUNDS.ASSIGN.RETRY' | translate }}</button>
      } @else {
        @for (assignment of assignments; track assignment.BusinessId) {
          <div class="fvr-assign__row">
            <span class="fvr-assign__name">{{ assignment.BusinessName }}</span>
            <button
              type="button"
              class="fas-btn fas-btn--text"
              [disabled]="saving"
              [attr.aria-label]="'FLEXI_SAFETY_ROUNDS.EDITOR.REMOVE_ARIA' | translate: { name: assignment.BusinessName }"
              (click)="confirmUnassign(assignment)"
            >{{ 'FLEXI_SAFETY_ROUNDS.EDITOR.REMOVE' | translate }}</button>
          </div>
        } @empty {
          <p class="fas-muted">{{ 'FLEXI_SAFETY_ROUNDS.EDITOR.NO_ASSIGNMENTS' | translate }}</p>
        }
      }
    </div>

    @if (canAssign) {
      <label class="fvr-search fvr-assign__search">
        <span class="fas-sr-only">{{ 'FLEXI_SAFETY_ROUNDS.ASSIGN.SEARCH' | translate }}</span>
        <i class="pi pi-search" aria-hidden="true"></i>
        <input
          pInputText
          type="search"
          maxlength="200"
          [disabled]="saving"
          [(ngModel)]="search"
          (ngModelChange)="searchChanged()"
          [placeholder]="'FLEXI_SAFETY_ROUNDS.ASSIGN.SEARCH' | translate"
        />
      </label>

      @if (loadFailed) {
        <p class="fas-error" role="alert">{{ 'FLEXI_SAFETY_ROUNDS.LOAD_FAILED' | translate }}</p>
      }

      <div class="fvr-assign__list" role="group" [attr.aria-label]="'FLEXI_SAFETY_ROUNDS.ASSIGN.BUSINESSES' | translate">
        @if (loading) {
          <flexi-safety-round-skeleton />
        } @else {
          @for (candidate of candidates; track candidate.BusinessId) {
            <label class="fvr-assign__row" [class.fvr-assign__row--has]="candidate.HasTemplate">
              <input
                type="checkbox"
                [checked]="isTicked(candidate)"
                [disabled]="candidate.HasTemplate || saving"
                (change)="toggle(candidate)"
              />
              <span class="fvr-assign__name">{{ candidate.BusinessName }}</span>
              @if (candidate.HasTemplate) {
                <span class="fas-badge fas-badge--inactive">{{ 'FLEXI_SAFETY_ROUNDS.ASSIGN.HAS_TEMPLATE' | translate }}</span>
              }
            </label>
          } @empty {
            <p class="fas-muted">{{ 'FLEXI_SAFETY_ROUNDS.ASSIGN.NO_MATCH' | translate }}</p>
          }
        }
      </div>

      <label class="fvr-check">
        <input type="checkbox" [(ngModel)]="makeDefault" [disabled]="saving" />
        <span>{{ 'FLEXI_SAFETY_ROUNDS.ASSIGN.MAKE_DEFAULT' | translate }}</span>
      </label>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="fas-dialog-actions fvr-assign__actions">
      <button type="button" class="fas-btn fas-btn--ghost" [disabled]="saving" (click)="cancel()">
        {{ 'CLOSE' | translate }}
      </button>
      @if (canAssign) {
        <button type="button" class="fas-btn fas-btn--primary" [disabled]="!ticked.size || saving" (click)="submit()">
          @if (saving) {
            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          }
          {{ (saving ? 'FLEXI_SAFETY_ROUNDS.SAVING' : 'FLEXI_SAFETY_ROUNDS.ASSIGN.SUBMIT') | translate: { count: ticked.size } }}
        </button>
      }
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog key="fvrAssign" [style]="{ width: '480px', maxWidth: '95vw' }"></p-confirmDialog>
